import { createBrowserRouter, matchRoutes, redirect } from 'react-router-dom'
import { getStorage, getURLSearchParams, setStorage } from '@mkmp/core'
import { getAuthUrl } from '@/utils'
import { getVendors, validateUser } from '@/service'
import { createModuleRoutes } from './modules'
import { useAppStore } from '@/stores'

const routes = createModuleRoutes()

/**
 * 根据pathname匹配路由
 * @param pathname
 * @returns
 */
const getRouteHandle = (pathname: string) => {
  const matches: any = matchRoutes(routes, pathname)
  if (matches?.length) {
    return matches[matches.length - 1].route.handle || {}
  }
  return {}
}

/**
 * 跳转相关的供应商主体
 */
const toPageUrl = async () => {
  const vendors = await getVendors()
  if (Array.isArray(vendors) && vendors.length === 1) {
    setStorage('app-supplier-id', vendors[0].id)
    setStorage('app-supplier-contact-id', vendors[0].contactId)
    setStorage('app-supplier', vendors[0])
    return '/order'
  } else {
    return '/vendor'
  }
}

/**
 * 验证用户信息是否完善
 */
const validateUserPerfect = async (params: any) => {
  const { user: storeUser, initData } = useAppStore.getState()
  if (!storeUser) {
    const { user } = await initData()
    if (user?.status === 1) {
      throw redirect('/perfect?' + params.toString())
    }
  } else {
    console.log('storeUser:', storeUser)
    if (storeUser.status === 1) {
      throw redirect('/perfect?' + params.toString())
    }
  }
}

/**
 * root loader校验身份
 * @param param0
 * @returns
 */
const rootLoader = async ({ request }: any) => {
  const token = getStorage('token')
  const pathname = new URL(request.url).pathname

  // 记录访问地址
  const params = new URLSearchParams()
  params.set('redirect', encodeURIComponent(request.url))

  if (token) {
    if (pathname !== '/perfect') {
      await validateUserPerfect(params)
    }

    console.log('pathname:', pathname)
    if (pathname === '/') {
      const url = await toPageUrl()
      throw redirect(url)
    }

    const { handle = {} } = getRouteHandle(pathname)
    document.title = handle?.title || '美洋金融传播'

    return null
  }

  const { handle = {} } = getRouteHandle(pathname)

  if (handle?.isPublic) {
    return null
  }

  const wechatCode = getURLSearchParams('code')
  const wechatState = getURLSearchParams('state')

  if (wechatCode && wechatState === 'STATE') {
    const result = await validateUser(wechatCode)
    if (parseInt(result.code) === 1) {
      throw redirect('/unauth')
    }

    setStorage('token', result.token)

    const url = await toPageUrl()
    throw redirect(url)
  } else {
    const authUrl =
      process.env.API_AUTHORIZE_URL +
      '/wechat/authorize?redirect=' +
      encodeURIComponent(window.location.origin + '/?' + params.toString())

    throw redirect(getAuthUrl(process.env.APP_WECHAT_ID || '', encodeURIComponent(authUrl), 'snsapi_userinfo'))
  }
}
/**
 * 创建路由
 */
const router = createBrowserRouter([
  {
    path: '/',
    loader: rootLoader,
    children: routes
  }
])

export { router }
